/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectAzureSourceAccountRequest {
  /**
  * The tenant ID. This field is required. 
  */
  'tenantId': string;
  /**
  * The subscription ID. This field is required if managementGroupId is not provided. (Cannot be provided together with managementGroupId.) 
  */
  'subscriptionId'?: string;
  /**
  * The management group ID. This field is required if subscriptionId is not provided. (Cannot be provided together with subscriptionId.) 
  */
  'managementGroupId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "managementGroupId",
      "baseName": "managementGroupId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectAzureSourceAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

